import { render } from "./FavoritePlanOptions.vue?vue&type=template&id=7196c72e"
import script from "./FavoritePlanOptions.vue?vue&type=script&lang=js"
export * from "./FavoritePlanOptions.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__